export default theme => ({
  typography: {
    padding: theme.spacing(2)
  },
  feedbackIcons: {
    width: 20,
    height: 20
  },
  feedbackIconActive: {
    color: theme.palette.primary.main,
    width: 20,
    height: 20
  },
  starButton: {
    marginLeft: 5,
    width: 30
  },
  actionButton: {
    border: `1px solid ${theme.palette.text.veryLight}`,
    color: theme.palette.text.veryLight,
    minWidth: 27,
    marginRight: 5,
    padding: "unset",
    "&:hover":{
      border: `1px solid ${theme.palette.primary.main}` ,
      color: theme.palette.primary.main
    },
    "&.Mui-selected":{
      border: `1px solid ${theme.palette.primary.main}!important`,
      color: theme.palette.primary.main,
      background: "#fff"
    },
  }
});
